var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0902 1.31962C13.7421 1.97152 13.7421 3.02847 13.0902 3.68037L4.45108 12.3194L13.0902 20.9585C13.7421 21.6104 13.7421 22.6674 13.0902 23.3193C12.4382 23.9712 11.3813 23.9712 10.7294 23.3193L0.909949 13.4998C0.258044 12.8479 0.258045 11.791 0.909949 11.1391L10.7294 1.31962C11.3813 0.667712 12.4382 0.667712 13.0902 1.31962Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.3c8d301be4c54321586a8e6f93006460.svg";
export { ForwardRef as ReactComponent };